import _regeneratorRuntime from '@babel/runtime/regenerator';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';

function pollDeferred(process, complete, timeGap, startTimeGap) {
  return new Promise(function (resolve, reject) {
    function iterate() {
      process().then(function (val) {
        try {
          if (complete(val)) resolve(val);else setTimeout(iterate, timeGap);
        } catch (e) {
          reject(e);
        }
      }, function (err) {
        return reject(err);
      });
    }
    setTimeout(iterate, startTimeGap || 0);
  });
}
function parametrizeUrl(url, params) {
  return url.replace(/:(\w+)/g, function (_, val) {
    return params[val];
  });
}
function request(method, url, data, headers) {
  var requestUrl = url;
  if (data && method === 'GET') requestUrl = parametrizeUrl(url, data);
  return fetch(requestUrl, {
    method: method,
    headers: Object.assign({
      Accept: 'application/json'
    }, headers),
    body: method !== 'GET' ? data : undefined,
    credentials: 'same-origin'
  }).then(function (response) {
    return response.json().then(function (res) {
      return response.ok ? res : Promise.reject(res.error);
    });
  })["catch"](function (err) {
    throw Error(err);
  });
}
function indigoCall(method, url, baseUrl, defaultOptions) {
  return function (data, options) {
    var body = Object.assign({}, data);
    body.options = Object.assign(body.options || {}, defaultOptions, options);
    return request(method, baseUrl + url, JSON.stringify(body), {
      'Content-Type': 'application/json'
    });
  };
}
var RemoteStructService = function () {
  function RemoteStructService(apiPath, defaultOptions) {
    _classCallCheck(this, RemoteStructService);
    this.apiPath = apiPath;
    this.defaultOptions = defaultOptions;
  }
  _createClass(RemoteStructService, [{
    key: "info",
    value: function () {
      var _info = _asyncToGenerator( _regeneratorRuntime.mark(function _callee() {
        var indigoVersion, imagoVersions, isAvailable, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isAvailable = false;
                _context.prev = 1;
                _context.next = 4;
                return request('GET', this.apiPath + 'info');
              case 4:
                response = _context.sent;
                indigoVersion = response['indigo_version'];
                imagoVersions = response['imago_versions'];
                isAvailable = true;
                _context.next = 15;
                break;
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                indigoVersion = '';
                imagoVersions = [];
                isAvailable = false;
              case 15:
                return _context.abrupt("return", {
                  indigoVersion: indigoVersion,
                  imagoVersions: imagoVersions,
                  isAvailable: isAvailable
                });
              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 10]]);
      }));
      function info() {
        return _info.apply(this, arguments);
      }
      return info;
    }()
  }, {
    key: "convert",
    value: function convert(data, options) {
      return indigoCall('POST', 'indigo/convert', this.apiPath, this.defaultOptions)(data, options);
    }
  }, {
    key: "layout",
    value: function layout(data, options) {
      return indigoCall('POST', 'indigo/layout', this.apiPath, this.defaultOptions)(data, options);
    }
  }, {
    key: "clean",
    value: function clean(data, options) {
      return indigoCall('POST', 'indigo/clean', this.apiPath, this.defaultOptions)(data, options);
    }
  }, {
    key: "aromatize",
    value: function aromatize(data, options) {
      return indigoCall('POST', 'indigo/aromatize', this.apiPath, this.defaultOptions)(data, options);
    }
  }, {
    key: "dearomatize",
    value: function dearomatize(data, options) {
      return indigoCall('POST', 'indigo/dearomatize', this.apiPath, this.defaultOptions)(data, options);
    }
  }, {
    key: "calculateCip",
    value: function calculateCip(data, options) {
      return indigoCall('POST', 'indigo/calculate_cip', this.apiPath, this.defaultOptions)(data, options);
    }
  }, {
    key: "automap",
    value: function automap(data, options) {
      return indigoCall('POST', 'indigo/automap', this.apiPath, this.defaultOptions)(data, options);
    }
  }, {
    key: "check",
    value: function check(data, options) {
      return indigoCall('POST', 'indigo/check', this.apiPath, this.defaultOptions)(data, options);
    }
  }, {
    key: "calculate",
    value: function calculate(data, options) {
      return indigoCall('POST', 'indigo/calculate', this.apiPath, this.defaultOptions)(data, options);
    }
  }, {
    key: "recognize",
    value: function recognize(blob, version) {
      var parVersion = version ? "?version=".concat(version) : '';
      var req = request('POST', this.apiPath + "imago/uploads".concat(parVersion), blob, {
        'Content-Type': blob.type || 'application/octet-stream'
      });
      var status = request.bind(null, 'GET', this.apiPath + 'imago/uploads/:id');
      return req.then(function (data) {
        return pollDeferred(status.bind(null, {
          id: data.upload_id
        }), function (response) {
          if (response.state === 'FAILURE') throw response;
          return response.state === 'SUCCESS';
        }, 500, 300);
      }).then(function (response) {
        return {
          struct: response.metadata.mol_str
        };
      });
    }
  }, {
    key: "generateImageAsBase64",
    value: function generateImageAsBase64(data, options) {
      return indigoCall('POST', 'indigo/render', this.apiPath, this.defaultOptions)({
        struct: data
      }, options);
    }
  }]);
  return RemoteStructService;
}();

var RemoteStructServiceProvider = function () {
  function RemoteStructServiceProvider(apiPath) {
    _classCallCheck(this, RemoteStructServiceProvider);
    this.mode = 'remote';
    var currentApiPath = apiPath;
    var params = new URLSearchParams(document.location.search);
    if (params.has('api_path')) {
      currentApiPath = params.get('api_path');
    }
    this.apiPath = !currentApiPath || /\/$/.test(currentApiPath) ? currentApiPath : currentApiPath + '/';
  }
  _createClass(RemoteStructServiceProvider, [{
    key: "createStructService",
    value: function createStructService(options) {
      return new RemoteStructService(this.apiPath, options);
    }
  }]);
  return RemoteStructServiceProvider;
}();

var ChemicalMimeType;
(function (ChemicalMimeType) {
  ChemicalMimeType["Mol"] = "chemical/x-mdl-molfile";
  ChemicalMimeType["Rxn"] = "chemical/x-mdl-rxnfile";
  ChemicalMimeType["DaylightSmiles"] = "chemical/x-daylight-smiles";
  ChemicalMimeType["ExtendedSmiles"] = "chemical/x-chemaxon-cxsmiles";
  ChemicalMimeType["DaylightSmarts"] = "chemical/x-daylight-smarts";
  ChemicalMimeType["InChI"] = "chemical/x-inchi";
  ChemicalMimeType["InChIAuxInfo"] = "chemical/x-inchi-aux";
  ChemicalMimeType["CML"] = "chemical/x-cml";
  ChemicalMimeType["KET"] = "application/json";
})(ChemicalMimeType || (ChemicalMimeType = {}));

var SupportedFormatProperties = function SupportedFormatProperties(name, mime, extensions, supportsCoords, options) {
  _classCallCheck(this, SupportedFormatProperties);
  this.name = name;
  this.mime = mime;
  this.extensions = extensions;
  this.supportsCoords = supportsCoords || false;
  this.options = options || {};
};

var formatProperties = {
  mol: new SupportedFormatProperties('MDL Molfile V2000', ChemicalMimeType.Mol, ['.mol'], true),
  molV3000: new SupportedFormatProperties('MDL Molfile V3000', ChemicalMimeType.Mol, ['.mol'], true, {
    'molfile-saving-mode': '3000'
  }),
  rxn: new SupportedFormatProperties('MDL Rxnfile V2000', ChemicalMimeType.Rxn, ['.rxn'], true),
  rxnV3000: new SupportedFormatProperties('MDL Rxnfile V3000', ChemicalMimeType.Rxn, ['.rxn'], true, {
    'molfile-saving-mode': '3000'
  }),
  smiles: new SupportedFormatProperties('Daylight SMILES', ChemicalMimeType.DaylightSmiles, ['.smi', '.smiles']),
  smilesExt: new SupportedFormatProperties('Extended SMILES', ChemicalMimeType.ExtendedSmiles, ['.cxsmi', '.cxsmiles']),
  smarts: new SupportedFormatProperties('Daylight SMARTS', ChemicalMimeType.DaylightSmarts, ['.smarts']),
  inChI: new SupportedFormatProperties('InChI', ChemicalMimeType.InChI, ['.inchi']),
  inChIAuxInfo: new SupportedFormatProperties('InChI AuxInfo', ChemicalMimeType.InChIAuxInfo, ['.inchi']),
  cml: new SupportedFormatProperties('CML', ChemicalMimeType.CML, ['.cml', '.mrv'], true),
  graph: new SupportedFormatProperties('Graph Format', ChemicalMimeType.KET, ['.ket'])
};
function getPropertiesByFormat(format) {
  return formatProperties[format];
}

var GraphFormatter = function () {
  function GraphFormatter(graphManager) {
    _classCallCheck(this, GraphFormatter);
    this.graphManager = graphManager;
  }
  _createClass(GraphFormatter, [{
    key: "getStructureFromStructAsync",
    value: function getStructureFromStructAsync(struct) {
      var graph = this.graphManager.toGraph(struct);
      var stringifiedGraph = JSON.stringify(graph, null, 4);
      return Promise.resolve(stringifiedGraph);
    }
  }, {
    key: "getStructureFromStringAsync",
    value: function getStructureFromStringAsync(stringifiedStruct) {
      var parsedStruct = JSON.parse(stringifiedStruct);
      var graph = this.graphManager.fromGraph(parsedStruct);
      return Promise.resolve(graph);
    }
  }]);
  return GraphFormatter;
}();

var MolfileV2000Formatter = function () {
  function MolfileV2000Formatter(molfileManager, options) {
    _classCallCheck(this, MolfileV2000Formatter);
    this.molfileManager = molfileManager;
    this.options = options;
  }
  _createClass(MolfileV2000Formatter, [{
    key: "getStructureFromStructAsync",
    value: function () {
      var _getStructureFromStructAsync = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(struct) {
        var stringifiedMolfile;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                stringifiedMolfile = this.molfileManager.stringify(struct);
                return _context.abrupt("return", stringifiedMolfile);
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getStructureFromStructAsync(_x) {
        return _getStructureFromStructAsync.apply(this, arguments);
      }
      return getStructureFromStructAsync;
    }()
  }, {
    key: "getStructureFromStringAsync",
    value: function () {
      var _getStructureFromStringAsync = _asyncToGenerator( _regeneratorRuntime.mark(function _callee2(stringifiedStruct) {
        var struct;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                struct = this.molfileManager.parse(stringifiedStruct, this.options);
                return _context2.abrupt("return", struct);
              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getStructureFromStringAsync(_x2) {
        return _getStructureFromStringAsync.apply(this, arguments);
      }
      return getStructureFromStringAsync;
    }()
  }]);
  return MolfileV2000Formatter;
}();

var RxnFormatter = function () {
  function RxnFormatter(molfileManager, options) {
    _classCallCheck(this, RxnFormatter);
    this.molfileManager = molfileManager;
    this.options = options;
  }
  _createClass(RxnFormatter, [{
    key: "getStructureFromStructAsync",
    value: function getStructureFromStructAsync(struct) {
      var stringifiedMolfile = this.molfileManager.stringify(struct);
      return Promise.resolve(stringifiedMolfile);
    }
  }, {
    key: "getStructureFromStringAsync",
    value: function getStructureFromStringAsync(stringifiedStruct) {
      var struct = this.molfileManager.parse(stringifiedStruct, this.options);
      return Promise.resolve(struct);
    }
  }]);
  return RxnFormatter;
}();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ServerFormatter = function () {
  function ServerFormatter(structService, molfileManager, format, options) {
    _classCallCheck(this, ServerFormatter);
    this.structService = structService;
    this.molfileManager = molfileManager;
    this.format = format;
    this.options = options;
  }
  _createClass(ServerFormatter, [{
    key: "getStructureFromStructAsync",
    value: function () {
      var _getStructureFromStructAsync = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(struct) {
        var infoResult, formatProperties, stringifiedStruct, convertResult, message;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.structService.info();
              case 2:
                infoResult = _context.sent;
                if (infoResult.isAvailable) {
                  _context.next = 5;
                  break;
                }
                throw new Error('Server is not available');
              case 5:
                formatProperties = getPropertiesByFormat(this.format);
                _context.prev = 6;
                stringifiedStruct = this.molfileManager.stringify(struct);
                _context.next = 10;
                return this.structService.convert({
                  struct: stringifiedStruct,
                  output_format: formatProperties.mime
                }, _objectSpread(_objectSpread({}, this.options), formatProperties.options));
              case 10:
                convertResult = _context.sent;
                return _context.abrupt("return", convertResult.struct);
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](6);
                if (_context.t0.message === 'Server is not compatible') {
                  message = "".concat(formatProperties.name, " is not supported in standalone mode.");
                } else {
                  message = "Convert error!\n".concat(_context.t0.message || _context.t0);
                }
                throw new Error(message);
              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 14]]);
      }));
      function getStructureFromStructAsync(_x) {
        return _getStructureFromStructAsync.apply(this, arguments);
      }
      return getStructureFromStructAsync;
    }()
  }, {
    key: "getStructureFromStringAsync",
    value: function () {
      var _getStructureFromStringAsync = _asyncToGenerator( _regeneratorRuntime.mark(function _callee2(stringifiedStruct) {
        var infoResult, promise, data, withCoords, result, parsedStruct, formatError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.structService.info();
              case 2:
                infoResult = _context2.sent;
                if (infoResult.isAvailable) {
                  _context2.next = 5;
                  break;
                }
                throw new Error('Server is not available');
              case 5:
                data = {
                  struct: undefined,
                  output_format: getPropertiesByFormat('mol').mime
                };
                withCoords = getPropertiesByFormat(this.format).supportsCoords;
                if (withCoords) {
                  promise = this.structService.convert;
                  data.struct = stringifiedStruct;
                } else {
                  promise = this.structService.layout;
                  data.struct = stringifiedStruct.trim();
                }
                _context2.prev = 8;
                _context2.next = 11;
                return promise(data, this.options);
              case 11:
                result = _context2.sent;
                parsedStruct = this.molfileManager.parse(result.struct);
                if (!withCoords) {
                  parsedStruct.rescale();
                }
                return _context2.abrupt("return", parsedStruct);
              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](8);
                if (!(_context2.t0.message !== 'Server is not compatible')) {
                  _context2.next = 21;
                  break;
                }
                throw Error("Convert error!\n".concat(_context2.t0.message || _context2.t0));
              case 21:
                formatError = this.format === 'smiles' ? "".concat(getPropertiesByFormat('smilesExt').name, " and opening of ").concat(getPropertiesByFormat('smiles').name) : getPropertiesByFormat(this.format).name;
                throw Error("".concat(formatError, " is not supported in standalone mode."));
              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 17]]);
      }));
      function getStructureFromStringAsync(_x2) {
        return _getStructureFromStringAsync.apply(this, arguments);
      }
      return getStructureFromStringAsync;
    }()
  }]);
  return ServerFormatter;
}();

var SmilesFormatter = function () {
  function SmilesFormatter(smilesManager,
  structService, molfileManager, format, options) {
    _classCallCheck(this, SmilesFormatter);
    this.smilesManager = smilesManager;
    this.structService = structService;
    this.molfileManager = molfileManager;
    this.format = format;
    this.options = options;
  }
  _createClass(SmilesFormatter, [{
    key: "getStructureFromStructAsync",
    value: function getStructureFromStructAsync(struct) {
      var stringifiedMolfile = this.smilesManager.stringify(struct);
      return Promise.resolve(stringifiedMolfile);
    }
  }, {
    key: "getStructureFromStringAsync",
    value: function getStructureFromStringAsync(stringifiedStruct) {
      var serverFormatter = new ServerFormatter(this.structService, this.molfileManager, this.format, this.options);
      return serverFormatter.getStructureFromStringAsync(stringifiedStruct);
    }
  }]);
  return SmilesFormatter;
}();

var FormatterFactory = function () {
  function FormatterFactory(structService, graphManager, molfileManager, smilesManager) {
    _classCallCheck(this, FormatterFactory);
    this.structService = structService;
    this.graphManager = graphManager;
    this.molfileManager = molfileManager;
    this.smilesManager = smilesManager;
  }
  _createClass(FormatterFactory, [{
    key: "separateOptions",
    value: function separateOptions(options) {
      if (!options) {
        return [{}, {}];
      }
      var reactionRelayout = options.reactionRelayout,
          badHeaderRecover = options.badHeaderRecover,
          structServiceOptions = _objectWithoutProperties(options, ["reactionRelayout", "badHeaderRecover"]);
      var molfileParseOptions = {};
      if (typeof reactionRelayout === 'boolean') {
        molfileParseOptions.reactionRelayout = reactionRelayout;
      }
      if (typeof badHeaderRecover === 'boolean') {
        molfileParseOptions.badHeaderRecover = badHeaderRecover;
      }
      return [molfileParseOptions, structServiceOptions];
    }
  }, {
    key: "create",
    value: function create(format, options) {
      var _this$separateOptions = this.separateOptions(options),
          _this$separateOptions2 = _slicedToArray(_this$separateOptions, 2),
          molfileParseOptions = _this$separateOptions2[0],
          structServiceOptions = _this$separateOptions2[1];
      var formatter;
      switch (format) {
        case 'graph':
          formatter = new GraphFormatter(this.graphManager);
          break;
        case 'mol':
          formatter = new MolfileV2000Formatter(this.molfileManager, molfileParseOptions);
          break;
        case 'rxn':
          formatter = new RxnFormatter(this.molfileManager, molfileParseOptions);
          break;
        case 'smiles':
          formatter = new SmilesFormatter(this.smilesManager,
          this.structService, this.molfileManager, format, structServiceOptions);
          break;
        case 'cml':
        case 'inChIAuxInfo':
        case 'inChI':
        case 'molV3000':
        case 'rxnV3000':
        case 'smilesExt':
        case 'smarts':
        default:
          formatter = new ServerFormatter(this.structService, this.molfileManager, format, structServiceOptions);
      }
      return formatter;
    }
  }]);
  return FormatterFactory;
}();

function identifyStructFormat(stringifiedStruct) {
  var sanitizedString = stringifiedStruct.trim();
  try {
    if (JSON.parse(sanitizedString)) {
      return 'graph';
    }
  } catch (er) {}
  if (sanitizedString.indexOf('$RXN') !== -1) {
    return 'rxn';
  }
  var match = sanitizedString.match(/^(M {2}END|\$END MOL)$/m);
  if (match) {
    var end = (match.index || 0) + match[0].length;
    if (end === sanitizedString.length || sanitizedString.slice(end, end + 20).search(/^\$(MOL|END CTAB)$/m) !== -1) {
      return 'mol';
    }
  }
  if (sanitizedString[0] === '<' && sanitizedString.indexOf('<molecule') !== -1) {
    return 'cml';
  }
  if (sanitizedString.slice(0, 5) === 'InChI') {
    return 'inChI';
  }
  if (sanitizedString.indexOf('\n') === -1) {
    return 'smiles';
  }
  return 'mol';
}

export { ChemicalMimeType, FormatterFactory, RemoteStructService, RemoteStructServiceProvider, formatProperties, getPropertiesByFormat, identifyStructFormat };
//# sourceMappingURL=index.modern.js.map
